/* eslint-disable prettier/prettier */
import { Link } from 'react-router-dom';
import { ButtonBase } from '@mui/material';
import { useSelector } from 'react-redux';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    const customization = useSelector((state) => state.customization);
    const passwordChanged = customization?.userDetail?.[0]?.user_detail?.change_password;

    return (
        <ButtonBase
            disableRipple
            component={Link}
            to={passwordChanged ? '/dashboard' : undefined} // 👈 redirect only if true
            onDragStart={(e) => e.preventDefault()} // 👈 Prevent drag start
            sx={{
                pointerEvents: passwordChanged ? 'auto' : 'none',
                cursor: passwordChanged ? 'pointer' : 'default',
                height: '80px'
            }}
        >
            {/* eslint-disable-next-line react/no-unknown-property */}
            <img loading="eager" fetchpriority="high" src="/Logo.v1.webp" alt="QuickCheck" width="60" height="60" draggable="false" />
        </ButtonBase>
    );
};
export default LogoSection;
